import { createReducer } from '@reduxjs/toolkit';

import { BpTypes, SyncStates } from '../../constants';
import { FetchStatus, PatientsSortBy, SortType } from '../../enums';
import * as actions from './actions';
import {
  IPatientsBpStatusFilter,
  IPatientsNewUserFilter,
  IPatientsSort,
  IPatientsState,
  IPatientsSyncStatusFilter,
} from './types';

export const bpStatusFilterInitialState = BpTypes.reduce(
  (acc, key) => ({
    ...acc,
    [key]: false,
  }),
  {} as IPatientsBpStatusFilter,
);

export const syncStatusFilterInitialState = SyncStates.reduce(
  (acc, key) => ({
    ...acc,
    [key]: false,
  }),
  {} as IPatientsSyncStatusFilter,
);

export const newUserFilterInitialState: IPatientsNewUserFilter = false;

export const sortInitialState: IPatientsSort = {
  by: PatientsSortBy.BP_TYPE,
  type: SortType.DESC,
};

export const initialState: IPatientsState = {
  patients: [],
  status: FetchStatus.IDLE,
  searchText: '',
  filters: {
    bpType: bpStatusFilterInitialState,
    syncState: syncStatusFilterInitialState,
    newUser: newUserFilterInitialState,
  },
  sort: sortInitialState,
};

export const patientsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(actions.resetPatients, () => initialState)
    .addCase(actions.updatePatientsSearchText, (state, action) => {
      state.searchText = action.payload.searchText;
    })
    .addCase(actions.updatePatientsBpStatusFilter, (state, action) => {
      state.filters.bpType = {
        ...state.filters.bpType,
        ...action.payload.filters,
      };
    })
    .addCase(actions.updatePatientsSyncStatusFilter, (state, action) => {
      state.filters.syncState = {
        ...state.filters.syncState,
        ...action.payload.filters,
      };
    })
    .addCase(actions.updatePatientsNewUserFilter, (state, action) => {
      state.filters.newUser = action.payload.newUser;
    })
    .addCase(actions.updatePatientsSort, (state, action) => {
      state.sort = {
        ...state.sort,
        ...action.payload.sort,
      };
    })
    .addCase(actions.fetchPatients, (state) => {
      state.status = FetchStatus.LOADING;
    })
    .addCase(actions.fetchPatientsSucceeded, (state, action) => {
      state.status = FetchStatus.SUCCESS;
      state.patients = action.payload.patients;
    })
    .addCase(actions.fetchPatientsFailed, (state) => {
      state.status = FetchStatus.FAILURE;
    });
});
